import styled from 'styled-components';

export const BasicInput = styled.input`
  height: 40px;
  width: 100%;

  display: flex;
  align-items: center;
  align-self: stretch;

  padding: 10px 16px;
  gap: 8px;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);

  &:read-only:not(.bg-white) {
    background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
    outline: none;
    border-color: #e4e4ed;
    box-shadow: none;
  }

  &::placeholder {
    color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);

    /* Body/Medium/m-regular */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }

  &.pointer {
    cursor: pointer;
  }
`;
